import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2026-07-27 14:54:12 +0200 (Mon, 27 Jul 2026) $
//  Author    : Olli Powroznik
//  Worker    : $Author: o.powroznik $
//  Revision  : $Rev: 164633 $
//  Purpose   : custom buttons
// =============================================================================
// ---Third-party imports
import React from 'react';
import clsx from 'clsx';
// ---Framework imports
import log from 'uix/logging';
import { VIcon } from 'uix/graphics';
// ---Local imports
import S from './button.css';
// ---Constants
const SIZES = {
    mini: 'mini',
    tiny: 'tiny',
    small: 'small',
    normal: 'normal',
    large: 'large',
    huge: 'huge',
    giant: 'giant'
};
const ICON_SIZES = {
    mini: 'mini',
    tiny: 'tiny',
    small: 'tiny',
    normal: 'small'
};
// ---Exports
export const Button = ({ disabled, circle = true, size = 'normal', onClick, content, icon, className, bordered, children, style, inverted })=>{
    let sizes = SIZES[size];
    let iconSizes = ICON_SIZES[size];
    return /*#__PURE__*/ _jsxs("div", {
        onClick: (e)=>{
            if (disabled) {
                e.stopPropagation();
                e.preventDefault();
                return;
            }
            onClick && onClick(e);
        },
        className: clsx(className, S.button, inverted && S.inverted, sizes && S[size], circle && S.circle, disabled && S.disabled, bordered && S.bordered, icon && S.icon),
        style: {
            ...style,
            ...disabled ? {
                pointerEvents: 'auto',
                cursor: 'default'
            } : {}
        },
        children: [
            content || children,
            icon && /*#__PURE__*/ _jsx(VIcon, {
                style: {
                    textShadow: 'none'
                },
                size: iconSizes ? iconSizes : undefined,
                name: icon
            })
        ]
    });
};
export const ButtonGroup = ({ children, vertical = false, style, floated, gap = '.3em' })=>{
    //filter empty children
    let childrn = children.filter((child)=>child !== undefined);
    return /*#__PURE__*/ _jsx("div", {
        className: clsx(S.buttonGroup, !vertical && S.horizontal, floated === 'right' && S.floatRight),
        style: style,
        children: childrn.map((child, i)=>{
            let gapStyle = gap ? {
                marginRight: `${gap}`
            } : null;
            if (childrn.length - 1 === i) {
                gapStyle = null;
            }
            if (child) {
                return /*#__PURE__*/ _jsx("div", {
                    style: gapStyle,
                    children: child
                }, i);
            }
        })
    });
};
